import { all, put, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import {
  FETCH_ALL_COURTS_REQUEST,
  FETCH_ALL_COURTS_SUCCESS,
  FETCH_ALL_COURTS_FAILURE,
  CREATE_COURT_REQUEST,
  CREATE_COURT_SUCCESS,
  CREATE_COURT_FAILURE,
  EDIT_COURT_REQUEST,
  EDIT_COURT_SUCCESS,
  EDIT_COURT_FAILURE,
  DELETE_COURT_REQUEST,
  DELETE_COURT_SUCCESS,
  DELETE_COURT_FAILURE,
  FETCH_AVAILABLE_COURTS_REQUEST,
  FETCH_AVAILABLE_COURTS_SUCCESS,
  FETCH_AVAILABLE_COURTS_FAILURE,
  SET_LOADING_STATE,
  RESET_LOADING_STATE,
} from "../constants";
import {
  firebaseFetchAllCourts,
  firebaseCreateCourt,
  firebaseEditCourt,
  firebaseDeleteCourt,
  firebaseFetchAvailableCourts,
} from "../api/court";

function* fetchAllCourtsFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseFetchAllCourts(payload);
    if (response) {
      yield put({
        type: FETCH_ALL_COURTS_SUCCESS,
        payload: { allCourts: response },
      });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: FETCH_ALL_COURTS_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: FETCH_ALL_COURTS_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* createCourtFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseCreateCourt(payload);
    if (response) {
      yield put({
        type: CREATE_COURT_SUCCESS,
        payload: { newCourt: response },
      });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: CREATE_COURT_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: CREATE_COURT_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* editCourtFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseEditCourt(payload);
    if (response) {
      yield put({ type: EDIT_COURT_SUCCESS, payload: { allCourts: response } });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: EDIT_COURT_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: EDIT_COURT_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* deleteCourtFn({ payload }: any): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseDeleteCourt(payload);
    if (response) {
      yield put({
        type: DELETE_COURT_SUCCESS,
        payload: { allCourts: response },
      });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: DELETE_COURT_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: DELETE_COURT_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

function* fetchAvailableCourtsFn(): any {
  try {
    yield put({ type: SET_LOADING_STATE });
    const response = yield firebaseFetchAvailableCourts();
    if (response) {
      yield put({
        type: FETCH_AVAILABLE_COURTS_SUCCESS,
        payload: { allCourts: response },
      });
      yield put({ type: RESET_LOADING_STATE });
    } else {
      yield put({ type: FETCH_AVAILABLE_COURTS_FAILURE });
      yield put({ type: RESET_LOADING_STATE });
    }
  } catch (err) {
    yield put({ type: FETCH_AVAILABLE_COURTS_FAILURE });
    yield put({ type: RESET_LOADING_STATE });
  }
}

export default function* courtSaga(): SagaIterator {
  yield all([
    takeEvery(FETCH_ALL_COURTS_REQUEST, fetchAllCourtsFn),
    takeEvery(CREATE_COURT_REQUEST, createCourtFn),
    takeEvery(EDIT_COURT_REQUEST, editCourtFn),
    takeEvery(DELETE_COURT_REQUEST, deleteCourtFn),
    takeEvery(FETCH_AVAILABLE_COURTS_REQUEST, fetchAvailableCourtsFn),
  ]);
}
